import axios from 'axios';
import { set, forEach } from 'lodash';
import { shape } from './shape';

const debounce = (func, wait) => {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
};

export const sendLog = debounce((props, userId, userName, selectedTenant, userRole) => {
  const finalPayloadShape = {};
  ;
  forEach(props, (propValue, propKey) => {
    if (propValue !== undefined && propValue !== null) {
      const tagPath = shape[propKey];
      if (tagPath) {
        set(finalPayloadShape, tagPath, propValue);
      }
    }
  });

  set(finalPayloadShape, 'userId', userId);
  set(finalPayloadShape, 'UserName', userName);
  set(finalPayloadShape, 'selectedTenantId', selectedTenant);
  set(finalPayloadShape, 'userRole', userRole);
  set(finalPayloadShape, 'Component', 'page');

  if (!finalPayloadShape.elementName) {
    console.error('ElementName is required');
    return;
  }
  if (!finalPayloadShape.elementType) {
    console.error('ElementType is required');
    return;
  }
  if (!finalPayloadShape.selectedTenantId) {
    console.error('SelectedTenantId is required');
    return;
  }

  axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/EventLogs`, finalPayloadShape)}, 300); // Adjust debounce delay as needed
